import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnInit,
    Inject,
    signal
} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogModule,
    MatDialogRef
} from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'app-modal-notification',
    templateUrl: './modal-notification.component.html',
    standalone: true,
    imports: [
        CommonModule,
        MatIconModule,
        MatButtonModule,
        MatToolbarModule,
        MatTooltipModule,
        MatDialogModule
    ],
    changeDetection: ChangeDetectionStrategy.Default
})
export class ModalNotificationComponent implements OnInit {
    public message = signal<string>(null);
    public color = signal<string>(null);
    public duration = signal<number>(null);
    public multiline = signal<string[] | null>(null);
    public iconClass = signal<string | null>(null);

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public _data: {
            message: string;
            color: string;
            duration: number;
            multiline?: string[] | null;
            iconClass?: string | null;
        },
        private _matDialogRef: MatDialogRef<ModalNotificationComponent>
    ) {}

    ngOnInit() {
        if (this._data.message && this._data.color && this._data.duration) {
            this.message.set(this._data.message);
            this.color.set(this._data.color);
            this.duration.set(this._data.duration);
            this.iconClass.set(this._data.iconClass ?? null);
            if (this._data.multiline?.length) {
                this.multiline.set(this._data.multiline);
            }
            // setTimeout(() => this.close(), this.duration);
        }
    }

    close(data: boolean) {
        this._matDialogRef.close(data);
    }

    getColor(color: string) {
        switch (color) {
            case 'success':
                return 'green';
            case 'info':
                return '#2173c7';
            case 'warning':
                return '#efc100';
            case 'error':
                return 'red';
        }
    }
}
